import { useEffect, useRef } from 'react';

export default function ProblemSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) el.classList.add('opacity-100', 'translate-y-0'); },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const problems = [
    { icon: 'ri-error-warning-fill', label: 'Recurring Leaks' },
    { icon: 'ri-money-dollar-circle-fill', label: 'Escalating Costs' },
    { icon: 'ri-building-fill', label: 'Structural Deterioration' },
    { icon: 'ri-emotion-unhappy-fill', label: 'Loss of Confidence from Owners, Engineers & Insurers' },
  ];

  return (
    <section id="problem" className="bg-[#0a0e1a] py-20 md:py-28">
      <div
        ref={ref}
        className="max-w-5xl mx-auto px-4 md:px-8 opacity-0 translate-y-8 transition-all duration-700 ease-out"
      >
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-red-500/10 border border-red-500/30 text-red-400 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-5">
            The Real Problem
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-white mb-5 leading-tight">
            When Water Intrusion Becomes a Structural Risk
          </h2>
          <p className="text-base md:text-lg text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Not just a cosmetic issue. In garages, tunnels, basements, elevator pits, and podium slabs —
            active pathways under hydrostatic pressure where traditional methods fail.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mb-12">
          {problems.map((p) => (
            <div
              key={p.label}
              className="flex items-start gap-4 bg-red-500/5 border border-red-500/20 rounded-lg p-5"
            >
              <span className="w-8 h-8 flex items-center justify-center shrink-0 text-red-500 text-xl mt-0.5">
                <i className={p.icon}></i>
              </span>
              <span className="text-white font-semibold text-base">{p.label}</span>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-gray-400 text-base md:text-lg italic border-l-4 border-[#0055ff] pl-5 text-left max-w-2xl mx-auto">
            &ldquo;Patching symptoms makes the problem more complex and expensive over time.&rdquo;
          </p>
        </div>
      </div>
    </section>
  );
}
